<template>
  <div class="footer-box">
    <div class="c footer-relevant-box">
      <img class="left-imgs-box" src="../assets/study/footer/logo-footer-white.png" />
      <!-- <div class="site-category-box">
        <div class="category-items">
          <span class="link-name">融媒智库： </span>
          <a class="link-opt" target="_blank" href="https://www.jiaoyu.cn/media?type=mtkx">媒体快讯</a>
          <a class="link-opt" target="_blank" href="https://www.jiaoyu.cn/media?type=zjdt">职教动态</a>
          <a class="link-opt" target="_blank" href="https://www.jiaoyu.cn/media?type=rmzsk">融媒知识库</a>
        </div>
        <div class="category-items">
          <span class="link-name">课程资源： </span>
          <a class="link-opt" target="_blank" href="https://www.jiaoyu.cn/school/class?type=mtkx" :to="'/school/class'">全部课程</a>
        </div>

        <div class="category-items">
          <span class="link-name">院校服务： </span>
          <a class="link-opt" target="_blank" href="https://www.jiaoyu.cn/service/teaching?type=teaching">教学资源</a>
          <a class="link-opt" target="_blank" href="https://www.jiaoyu.cn/service/training?type=training">实训平台</a>
          <a class="link-opt" target="_blank" href="https://www.jiaoyu.cn/service/study?type=mtkx">在线学习平台</a>
        </div>
        <div class="category-items">
          <span class="link-name">党建思政： </span>
          <div class="link-opt" @click="goToThought(1)">党建服务</div>
          <div class="link-opt" @click="goToThought(2)">思政培训</div>
        </div>
      </div> -->
      <div class="site-address">
        <div>北京中教互联教育科技有限公司</div>
        <div>北京市海淀区文慧园北路9号今典花园9号楼-教育在线</div>
      </div>
      <div class="site-contact-box">
        <div class="category-items">
          <div class="items-left">
            <div class="label">业务合作</div>
            <div class="phone">王老师<br />13161510966</div>
          </div>
          <div class="items-right">
            <img class="wechat-imgs" src="../assets/site/home/wang.jpg" />
          </div>
        </div>
        <div class="category-items">
          <div class="items-left">
            <div class="label">公众号</div>
            <div class="phone">教育在线</div>
          </div>
          <div class="items-right">
            <img class="wechat-imgs" src="../assets/site/home/qrcode.jpg" />
          </div>
        </div>

      </div>
    </div>
    <p class="bottom-copyright">
      <span>版权所有</span>
      <!-- <span><a href="https://www.eol.cn" target="_blank">教育在线</a></span> -->
      <span>北京中教互联教育科技有限公司</span>
      <a href="http://www.eol.cn/html/cer.net/icp.htm" target="_blank">京ICP证140769号</a> |
      <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">京ICP备2022007846号-1 </a> |
      <a href="http://img.eol.cn/images/indexnew/www1024.jpg" target="_blank">京网文[2014]2106-306号</a> |
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020236" target="_blank">京公网安备 11010802020236号</a>
    </p>

  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    goToThought (type) {
      window.open(`https://www.jiaoyu.cn/thought?type=${type}`)
    }
  }
}
</script>

<style lang="less" scoped>
.footer-box * {
    text-align: left;
}
.c {
    width: 1200px;
    margin: 0 auto;
}
.footer-box {
    background-color: #161e30;
    color: #d6d6d6;
    font-size: 14px;
}
.footer-box .footer-relevant-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 60px 0 40px;
}
.footer-box .left-imgs-box {
    width: 189px;
    height: auto;
    margin-right: 70px;
}
.footer-box .right-wechat-box {
    width: 107px;
    text-align: center;
}
.footer-box .right-wechat-box div {
    text-align: center;
}
.footer-box .site-category-box {
    flex: 1;
    padding-left: 90px;
}
.footer-box .site-contact-box {
    flex: 1;
    padding-left: 60px;
    display: flex;
    .category-items {
        display: inline-block;
        display: flex;
        margin-right: 60px;
        .items-left {
            display: inline-block;
            margin-right: 20px;
            .label {
                font-weight: bold;
                font-size: 14px;
                color: #ffffff;
                margin-bottom: 20px;
            }
            .phone {
                font-weight: 400;
                font-size: 14px;
                color: #ffffff;
            }
        }
        .items-right {
            img {
                width: 90px;
                height: auto;
            }
        }
    }
}
.footer-box .link-opt {
    margin-right: 20px;
    cursor: pointer;
    display: inline-block;
    color: #d6d6d6;
}
.link-name {
    color: #fff;
}
.footer-box .link-opt:hover {
    color: #3d77ff;
    text-decoration: none;
}
.footer-box .wechat-imgs {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
}
.footer-box .bottom-copyright {
    background-color: #0d1422;
    height: 48px;
    line-height: 48px;
    text-align: center;
}
.bottom-copyright span,
.bottom-copyright a {
    display: inline-block;
    vertical-align: top;
    margin: 0 5px;
    color: #d1d0d0;
    font-size: 12px;
}
.bottom-copyright a:hover {
    color: #3d77ff;
    text-decoration: none;
}
.link-name.big {
    font-size: 16px;
    font-weight: bold;
}
</style>